import css from './dashboard-header.module.scss';

// The Today/Next-3-days/This-week/Custom window switcher lives in
// DashboardToolbar (XT341-003), so this header is title-only.
export const DashboardHeader = () => (
  <div className={css.root}>
    <div className={css.titleBlock}>
      <h1 className={css.title}>Ops Dashboard</h1>
    </div>
  </div>
);
